(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[397],{

/***/ 15627:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/why-sg",
      function () {
        return __webpack_require__(78670);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 15457:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "i": function() { return /* reexport */ Slider; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.m.js
var clsx_m = __webpack_require__(86010);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/swiper/swiper.esm.js + 90 modules
var swiper_esm = __webpack_require__(71911);
// EXTERNAL MODULE: ./node_modules/swiper/react/swiper-react.js + 15 modules
var swiper_react = __webpack_require__(30719);
// EXTERNAL MODULE: ./node_modules/swiper/swiper.min.css
var swiper_min = __webpack_require__(30933);
// EXTERNAL MODULE: ./node_modules/swiper/modules/autoplay/autoplay.min.css
var autoplay_min = __webpack_require__(65519);
// EXTERNAL MODULE: ./node_modules/swiper/modules/pagination/pagination.min.css
var pagination_min = __webpack_require__(68770);
// EXTERNAL MODULE: ./src/components/landingV4/common/Slider/Slider.module.scss
var Slider_module = __webpack_require__(97329);
var Slider_module_default = /*#__PURE__*/__webpack_require__.n(Slider_module);
;// CONCATENATED MODULE: ./src/components/landingV4/common/Slider/Slider.tsx







// eslint-disable-next-line import/no-unresolved

// eslint-disable-next-line import/no-unresolved

// eslint-disable-next-line import/no-unresolved


var Slider = function(param) {
    var items = param.items, _spaceBetween = param.spaceBetween, spaceBetween = _spaceBetween === void 0 ? 20 : _spaceBetween, _slidesPerView = param.slidesPerView, slidesPerView = _slidesPerView === void 0 ? 1 : _slidesPerView, breakpoints = param.breakpoints, _loop = param.loop, loop = _loop === void 0 ? false : _loop, _autoplay = param.autoplay, autoplay = _autoplay === void 0 ? false : _autoplay, _navigation = param.navigation, navigation = _navigation === void 0 ? false : _navigation, _className = param.className, className = _className === void 0 ? "" : _className;
    var swiperRef = (0,react.useRef)(null);
    var ref = (0,react.useState)({
        prev: true,
        next: false
    }), navDisabled = ref[0], setNavDisabled = ref[1];
    var syncNav = (0,react.useCallback)(function(swiper) {
        if (!navigation) return;
        if (swiper.isLocked) {
            setNavDisabled({
                prev: true,
                next: true
            });
            return;
        }
        if (loop) {
            setNavDisabled({
                prev: false,
                next: false
            });
            return;
        }
        setNavDisabled({
            prev: swiper.isBeginning,
            next: swiper.isEnd
        });
    }, [
        navigation,
        loop
    ]);
    var _id;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (0,clsx_m/* default */.Z)((Slider_module_default()).sliderWrapper, navigation && (Slider_module_default()).sliderWrapperWithNav),
        children: [
            navigation && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                        type: "button",
                        className: (0,clsx_m/* default */.Z)((Slider_module_default()).navBtn, (Slider_module_default()).navPrev),
                        disabled: navDisabled.prev,
                        "aria-label": "Previous slide",
                        onClick: function() {
                            var ref;
                            return (ref = swiperRef.current) === null || ref === void 0 ? void 0 : ref.slidePrev();
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            "aria-hidden": true,
                            children: "‹"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                        type: "button",
                        className: (0,clsx_m/* default */.Z)((Slider_module_default()).navBtn, (Slider_module_default()).navNext),
                        disabled: navDisabled.next,
                        "aria-label": "Next slide",
                        onClick: function() {
                            var ref;
                            return (ref = swiperRef.current) === null || ref === void 0 ? void 0 : ref.slideNext();
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            "aria-hidden": true,
                            children: "›"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(swiper_react/* Swiper */.tq, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                className: (0,clsx_m/* default */.Z)((Slider_module_default()).root, className),
                modules: [
                    swiper_esm/* Pagination */.tl,
                    swiper_esm/* Autoplay */.pt
                ],
                pagination: {
                    clickable: true
                },
                onSwiper: function(swiper) {
                    swiperRef.current = swiper;
                    syncNav(swiper);
                },
                onSlideChange: function(swiper) {
                    return syncNav(swiper);
                },
                onBreakpoint: function(swiper) {
                    return syncNav(swiper);
                },
                onResize: function(swiper) {
                    return syncNav(swiper);
                },
                spaceBetween: spaceBetween,
                slidesPerView: slidesPerView,
                breakpoints: breakpoints,
                loop: loop
            }, autoplay && {
                autoplay: {
                    delay: 5000,
                    pauseOnMouseEnter: true,
                    disableOnInteraction: false
                }
            }), {
                children: items.map(function(item, index) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(swiper_react/* SwiperSlide */.o5, {
                        children: item.content
                    }, (_id = item.id) !== null && _id !== void 0 ? _id : index);
                })
            }))
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/landingV4/common/Slider/index.ts



/***/ }),

/***/ 78670:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ why_sg; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/components/landingV4/FAQBlock/index.ts + 1 modules
var FAQBlock = __webpack_require__(51580);
// EXTERNAL MODULE: ./src/components/landingV4/FeedbackBlock/index.ts + 27 modules
var FeedbackBlock = __webpack_require__(52898);
// EXTERNAL MODULE: ./src/components/landingV4/Footer/index.ts + 1 modules
var Footer = __webpack_require__(60830);
// EXTERNAL MODULE: ./src/components/landingV4/Header/index.ts + 8 modules
var Header = __webpack_require__(13906);
// EXTERNAL MODULE: ./src/components/landingV4/SnackbarProvider/index.ts + 4 modules
var SnackbarProvider = __webpack_require__(7513);
// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.m.js
var clsx_m = __webpack_require__(86010);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./src/components/landingV4/common/Container/index.ts + 1 modules
var Container = __webpack_require__(67306);
// EXTERNAL MODULE: ./src/components/landingV4/common/Flex/index.ts + 1 modules
var Flex = __webpack_require__(75487);
// EXTERNAL MODULE: ./src/components/landingV4/common/Text/index.ts + 1 modules
var Text = __webpack_require__(50576);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
;// CONCATENATED MODULE: ./src/components/landingV4/whySg/icons/WhySgGlobalCoverageIcons.tsx



var chipIconSvgProps = {
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-hidden": true
};
var WhySgCoverageMajorCardsIcon = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, chipIconSvgProps), {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M2.66671 3.3335H13.3334C14.0693 3.3335 14.6667 3.93094 14.6667 4.66683V11.3335C14.6667 12.0694 14.0693 12.6668 13.3334 12.6668H2.66671C1.93082 12.6668 1.33337 12.0694 1.33337 11.3335V4.66683C1.33337 3.93094 1.93082 3.3335 2.66671 3.3335V3.3335",
                stroke: "currentColor",
                strokeWidth: "1.33333",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M1.33337 6.6665H14.6667",
                stroke: "currentColor",
                strokeWidth: "1.33333",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    }));
};
var WhySgCoverageDigitalWalletIcon = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, chipIconSvgProps), {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M12.6667 4.66667V2.66667C12.6667 2.29872 12.3679 2 12 2H3.33333C2.59745 2 2 2.59745 2 3.33333C2 4.06922 2.59745 4.66667 3.33333 4.66667H13.3333C13.7013 4.66667 14 4.96539 14 5.33333V8H12C11.2641 8 10.6667 8.59745 10.6667 9.33333C10.6667 10.0692 11.2641 10.6667 12 10.6667H14C14.3679 10.6667 14.6667 10.3679 14.6667 10V8.66667C14.6667 8.29872 14.3679 8 14 8",
                stroke: "currentColor",
                strokeWidth: "1.33333",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M2 3.3335V12.6668C2 13.4027 2.59745 14.0002 3.33333 14.0002H13.3333C13.7013 14.0002 14 13.7014 14 13.3335V10.6668",
                stroke: "currentColor",
                strokeWidth: "1.33333",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    }));
};
var WhySgCoverageBankTransferIcon = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, chipIconSvgProps), {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M6.66663 12.0002V7.3335",
                stroke: "currentColor",
                strokeWidth: "1.33333",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M7.41328 1.46555C7.78399 1.28548 8.21714 1.28695 8.58661 1.46955L13.8306 4.03422C14.1479 4.18955 14.0373 4.66689 13.6839 4.66689H2.31595C1.96261 4.66689 1.85261 4.18955 2.16928 4.03422L7.41328 1.46555",
                stroke: "currentColor",
                strokeWidth: "1.33333",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M9.33337 12.0002V7.3335",
                stroke: "currentColor",
                strokeWidth: "1.33333",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M12 12.0002V7.3335",
                stroke: "currentColor",
                strokeWidth: "1.33333",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M2 14.6665H14",
                stroke: "currentColor",
                strokeWidth: "1.33333",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M4 12.0002V7.3335",
                stroke: "currentColor",
                strokeWidth: "1.33333",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    }));
};
var WhySgCoverageLocalMethodsIcon = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, chipIconSvgProps), {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M13.3333 6.66683C13.3333 9.9955 9.64063 13.4622 8.40063 14.5328C8.16332 14.7113 7.8366 14.7113 7.59929 14.5328C6.35929 13.4622 2.66663 9.9955 2.66663 6.66683C2.66663 3.72328 5.05641 1.3335 7.99996 1.3335C10.9435 1.3335 13.3333 3.72328 13.3333 6.66683",
                stroke: "currentColor",
                strokeWidth: "1.33333",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M6 6.6665C6 7.77033 6.89617 8.6665 8 8.6665C9.10383 8.6665 10 7.77033 10 6.6665C10 5.56267 9.10383 4.6665 8 4.6665C6.89617 4.6665 6 5.56267 6 6.6665V6.6665",
                stroke: "currentColor",
                strokeWidth: "1.33333",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    }));
};

// EXTERNAL MODULE: ./src/components/landingV4/WhySgGlobalCoverageBlock/WhySgGlobalCoverageBlock.module.scss
var WhySgGlobalCoverageBlock_module = __webpack_require__(62267);
var WhySgGlobalCoverageBlock_module_default = /*#__PURE__*/__webpack_require__.n(WhySgGlobalCoverageBlock_module);
;// CONCATENATED MODULE: ./src/components/landingV4/WhySgGlobalCoverageBlock/WhySgGlobalCoverageBlock.tsx








/** Map raster: `why_sg_global_coverage_map.png` (896×516). For extra-large columns / Retina, use a wider export if it ever looks soft. */ var MAP_SRC = "/assets/why_sg_global_coverage_map.png";
var FEATURE_CHIPS = [
    {
        key: "cards",
        label: "Major Cards",
        Icon: WhySgCoverageMajorCardsIcon
    },
    {
        key: "wallets",
        label: "Digital Wallets",
        Icon: WhySgCoverageDigitalWalletIcon
    },
    {
        key: "bank",
        label: "Bank Transfers",
        Icon: WhySgCoverageBankTransferIcon
    },
    {
        key: "local",
        label: "Local Methods",
        Icon: WhySgCoverageLocalMethodsIcon
    }, 
];
var PROVIDER_TAGS = [
    "VISA",
    "Mastercard",
    "PayPal",
    "G Pay"
];
var STATS = [
    {
        value: "100+",
        label: "Countries"
    },
    {
        value: "300+",
        label: "Payment Methods"
    },
    {
        value: "50+",
        label: "Currencies"
    }, 
];
var WhySgGlobalCoverageBlock = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* Container */.W, {
        className: (WhySgGlobalCoverageBlock_module_default()).root,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: (WhySgGlobalCoverageBlock_module_default()).layout,
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (WhySgGlobalCoverageBlock_module_default()).contentRow,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (WhySgGlobalCoverageBlock_module_default()).leftColumn,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* Flex */.k, {
                                direction: "column",
                                gap: 4,
                                className: (WhySgGlobalCoverageBlock_module_default()).intro,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: (WhySgGlobalCoverageBlock_module_default()).sectionLabel,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                className: (WhySgGlobalCoverageBlock_module_default()).sectionLabelLine,
                                                "aria-hidden": true
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Text */.x, {
                                                type: "medium14",
                                                color: "green",
                                                className: (WhySgGlobalCoverageBlock_module_default()).sectionEyebrow,
                                                children: "Global coverage"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Text */.x, {
                                        type: "regular48",
                                        color: "white",
                                        className: (WhySgGlobalCoverageBlock_module_default()).title,
                                        children: "Global Reach, Local Presence"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Text */.x, {
                                        type: "regular16",
                                        color: "white50",
                                        whiteSpace: "normal",
                                        className: (WhySgGlobalCoverageBlock_module_default()).description,
                                        children: "Expand into new markets effortlessly. Support major card networks, digital wallets, and local payment methods across 100+ countries — all through a single integration."
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (WhySgGlobalCoverageBlock_module_default()).featureGrid,
                                role: "list",
                                children: FEATURE_CHIPS.map(function(param, index) {
                                    var key = param.key, label = param.label, Icon = param.Icon;
                                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: (0,clsx_m/* default */.Z)((WhySgGlobalCoverageBlock_module_default()).featureChip, index === FEATURE_CHIPS.length - 1 && (WhySgGlobalCoverageBlock_module_default()).featureChipSolo),
                                        role: "listitem",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                className: (WhySgGlobalCoverageBlock_module_default()).featureChipIcon,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon, {})
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Text */.x, {
                                                type: "medium14",
                                                color: "white",
                                                children: label
                                            })
                                        ]
                                    }, key);
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* Flex */.k, {
                                className: (WhySgGlobalCoverageBlock_module_default()).statsRow,
                                gap: 10,
                                wrap: "wrap",
                                children: STATS.map(function(param) {
                                    var value = param.value, label = param.label;
                                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: (WhySgGlobalCoverageBlock_module_default()).statItem,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Text */.x, {
                                                type: "regular48",
                                                color: "green",
                                                className: (WhySgGlobalCoverageBlock_module_default()).statValue,
                                                children: value
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Text */.x, {
                                                type: "regular14",
                                                color: "white50",
                                                children: label
                                            })
                                        ]
                                    }, label);
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (WhySgGlobalCoverageBlock_module_default()).visualColumn,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (WhySgGlobalCoverageBlock_module_default()).mapFigure,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                    className: (WhySgGlobalCoverageBlock_module_default()).mapImg,
                                    src: MAP_SRC,
                                    width: 896,
                                    height: 516,
                                    alt: "World map with coverage markers and Live in 100+ Countries — global payment footprint across continents.",
                                    layout: "responsive",
                                    sizes: "(min-width: 960px) 50vw, 100vw"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (WhySgGlobalCoverageBlock_module_default()).providers,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (WhySgGlobalCoverageBlock_module_default()).providersRow,
                                    children: PROVIDER_TAGS.map(function(name) {
                                        return /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            className: (WhySgGlobalCoverageBlock_module_default()).providerTag,
                                            children: name
                                        }, name);
                                    })
                                })
                            })
                        ]
                    })
                ]
            })
        })
    });
};

;// CONCATENATED MODULE: ./src/components/landingV4/WhySgGlobalCoverageBlock/index.ts


// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./src/components/landingV4/common/Slider/index.ts + 1 modules
var Slider = __webpack_require__(15457);
;// CONCATENATED MODULE: ./src/components/landingV4/whySg/icons/WhySgHeroIcons.tsx

var WhySgHeroRoutingIcon = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": true,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M2.5 15.8334C2.5 17.2132 3.62021 18.3334 5 18.3334C6.37979 18.3334 7.5 17.2132 7.5 15.8334C7.5 14.4536 6.37979 13.3334 5 13.3334C3.62021 13.3334 2.5 14.4536 2.5 15.8334H2.5",
                stroke: "currentColor",
                strokeWidth: "1.66667",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M7.5 15.8333H14.5833C16.1931 15.8333 17.5 14.5264 17.5 12.9166C17.5 11.3069 16.1931 9.99996 14.5833 9.99996H5.41667C3.80691 9.99996 2.5 8.69304 2.5 7.08329C2.5 5.47354 3.80691 4.16663 5.41667 4.16663H12.5",
                stroke: "currentColor",
                strokeWidth: "1.66667",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M12.5 4.16663C12.5 5.54641 13.6202 6.66663 15 6.66663C16.3798 6.66663 17.5 5.54641 17.5 4.16663C17.5 2.78684 16.3798 1.66663 15 1.66663C13.6202 1.66663 12.5 2.78684 12.5 4.16663Z",
                stroke: "currentColor",
                strokeWidth: "1.66667",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    });
};
var WhySgHeroBarChartIcon = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": true,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M2.5 2.5V15.8333C2.5 16.7538 3.24619 17.5 4.16667 17.5H17.5",
                stroke: "currentColor",
                strokeWidth: "1.66667",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M15 14.1667V7.5",
                stroke: "currentColor",
                strokeWidth: "1.66667",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M10.8333 14.1666V4.16663",
                stroke: "currentColor",
                strokeWidth: "1.66667",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M6.66667 14.1666V11.6666",
                stroke: "currentColor",
                strokeWidth: "1.66667",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/landingV4/whySg/icons/WhySgShieldCheckIcons.tsx

var WhySgShieldCheckHeroIcon = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: 22,
        height: 22,
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": true,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M12 2.5 4.5 5.2v5.3c0 4.5 3.1 8.7 7.5 9.7 4.4-1 7.5-5.2 7.5-9.7V5.2L12 2.5Z",
                stroke: "currentColor",
                strokeWidth: "1.5",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "m9 12 2 2 4-5",
                stroke: "currentColor",
                strokeWidth: "1.5",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    });
};
var WhySgShieldCheckSecurityCardIcon = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        viewBox: "0 0 32 32",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": true,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M5.13335 11.4934C4.73782 9.71171 5.28078 7.8515 6.57264 6.56234C7.86449 5.27319 9.72584 4.73412 11.5067 5.13338C12.4868 3.60056 14.1806 2.6731 16 2.6731C17.8194 2.6731 19.5133 3.60056 20.4933 5.13338C22.277 4.73236 24.1418 5.27287 25.4345 6.56559C26.7272 7.8583 27.2677 9.72306 26.8667 11.5067C28.3995 12.4868 29.327 14.1807 29.327 16C29.327 17.8194 28.3995 19.5133 26.8667 20.4934C27.2659 22.2742 26.7269 24.1356 25.4377 25.4274C24.1486 26.7193 22.2884 27.2622 20.5067 26.8667C19.5278 28.4055 17.8305 29.3375 16.0067 29.3375C14.1829 29.3375 12.4856 28.4055 11.5067 26.8667C9.72584 27.266 7.86449 26.7269 6.57264 25.4378C5.28078 24.1486 4.73782 22.2884 5.13335 20.5067C3.58852 19.5291 2.6521 17.8283 2.6521 16C2.6521 14.1718 3.58852 12.471 5.13335 11.4934V11.4934",
                stroke: "currentColor",
                strokeWidth: "2.66667",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M12 15.9999L14.6667 18.6666L20 13.3333",
                stroke: "currentColor",
                strokeWidth: "2.66667",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    });
};
var WhySgShieldCheckUptimeStatIcon = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        viewBox: "0 0 32 32",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": true,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M26.6667 17.3333C26.6667 23.9999 22 27.3333 16.4534 29.2666C16.1629 29.365 15.8474 29.3603 15.56 29.2533C10 27.3333 5.33337 23.9999 5.33337 17.3333V7.99995C5.33337 7.26406 5.93082 6.66662 6.66671 6.66662C9.33337 6.66662 12.6667 5.06662 14.9867 3.03995C15.5703 2.54137 16.4298 2.54137 17.0134 3.03995C19.3467 5.07995 22.6667 6.66662 25.3334 6.66662C26.0693 6.66662 26.6667 7.26406 26.6667 7.99995V17.3333",
                stroke: "currentColor",
                strokeWidth: "2.66667",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M12 16.0002L14.6667 18.6668L20 13.3335",
                stroke: "currentColor",
                strokeWidth: "2.66667",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    });
};

// EXTERNAL MODULE: ./src/components/landingV4/WhySgHero/WhySgHero.module.scss
var WhySgHero_module = __webpack_require__(29961);
var WhySgHero_module_default = /*#__PURE__*/__webpack_require__.n(WhySgHero_module);
;// CONCATENATED MODULE: ./src/components/landingV4/WhySgHero/WhySgHero.tsx











var FEATURES = [
    {
        category: "Technology",
        title: "Enterprise Security",
        description: "PCI DSS Level 1 compliant with tokenization and 3D Secure support built in.",
        icon: WhySgShieldCheckHeroIcon
    },
    {
        category: "Compliance",
        title: "Smart Routing",
        description: "Automatically route transactions to the best-performing acquirer based on real-time data.",
        icon: WhySgHeroRoutingIcon
    },
    {
        category: "Analytics",
        title: "Unified Analytics",
        description: "One dashboard for all payment providers with real-time insights and reconciliation.",
        icon: WhySgHeroBarChartIcon
    }, 
];
function FeatureSlideCard(props) {
    var category = props.category, title = props.title, description = props.description, icon = props.icon;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("article", {
        className: (WhySgHero_module_default()).card,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* Flex */.k, {
            className: (WhySgHero_module_default()).cardInner,
            direction: "column",
            alignItems: "flexStart",
            gap: 4,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* Flex */.k, {
                    className: (WhySgHero_module_default()).iconWrap,
                    alignItems: "center",
                    justifyContent: "center",
                    "aria-hidden": true,
                    children: icon
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Text */.x, {
                    type: "medium14",
                    className: (WhySgHero_module_default()).category,
                    children: category
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Text */.x, {
                    type: "h3",
                    color: "white",
                    children: title
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Text */.x, {
                    type: "regular14",
                    color: "white50",
                    whiteSpace: "normal",
                    children: description
                })
            ]
        })
    });
}
var WhySgHero = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* Container */.W, {
        className: (WhySgHero_module_default()).root,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* Flex */.k, {
            direction: "column",
            alignItems: "center",
            className: (WhySgHero_module_default()).intro,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Text */.x, {
                    type: "medium14",
                    align: "center",
                    className: (WhySgHero_module_default()).eyebrow,
                    children: "Why SmartGates?"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Text */.x, {
                    type: "medium64",
                    color: "white",
                    align: "center",
                    className: (WhySgHero_module_default()).headline,
                    children: "Scale your business with an intelligent data-driven payment ecosystem"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Text */.x, {
                    type: "regular16",
                    color: "white50",
                    align: "center",
                    whiteSpace: "normal",
                    className: (WhySgHero_module_default()).subhead,
                    children: "Connect to multiple acquirers and payment methods via a single integration. Get clear reporting, smart routing and enterprise-grade security from day one."
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Slider/* Slider */.i, {
                    navigation: true,
                    className: (WhySgHero_module_default()).slider,
                    items: FEATURES.map(function(_param) {
                        var Icon = _param.icon, rest = (0,_object_without_properties/* default */.Z)(_param, [
                            "icon"
                        ]);
                        return {
                            id: rest.title,
                            content: /*#__PURE__*/ (0,jsx_runtime.jsx)(FeatureSlideCard, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, rest), {
                                icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon, {})
                            }))
                        };
                    }),
                    slidesPerView: 1,
                    spaceBetween: 12,
                    breakpoints: {
                        960: {
                            slidesPerView: 2,
                            spaceBetween: 20
                        }
                    }
                })
            ]
        })
    });
};

;// CONCATENATED MODULE: ./src/components/landingV4/WhySgHero/index.ts


;// CONCATENATED MODULE: ./src/components/landingV4/whySg/icons/WhySgSecurityBlockIcons.tsx



var WhySgSecurityTechnologyCardIcon = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        viewBox: "0 0 32 32",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props), {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M16 24.0001V6.66675",
                stroke: "currentColor",
                strokeWidth: "2.66667",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M20 17.3333C17.6305 16.6407 16.0015 14.4686 16 12C15.9985 14.4686 14.3695 16.6407 12 17.3333",
                stroke: "currentColor",
                strokeWidth: "2.66667",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M23.464 8.66664C24.3049 7.21034 24.1451 5.3836 23.0642 4.09537C21.9833 2.80714 20.2121 2.33253 18.6318 2.90771C17.0516 3.48288 15.9999 4.985 16 6.66664C16 4.985 14.9483 3.48288 13.3681 2.90771C11.7879 2.33253 10.0167 2.80714 8.93574 4.09537C7.85483 5.3836 7.69508 7.21034 8.53597 8.66664",
                stroke: "currentColor",
                strokeWidth: "2.66667",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M23.996 6.83325C25.584 7.24157 26.8959 8.35767 27.5535 9.85972C28.2111 11.3618 28.1412 13.0828 27.364 14.5266",
                stroke: "currentColor",
                strokeWidth: "2.66667",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M24 24.0001C26.4138 24 28.5266 22.3787 29.1514 20.0471C29.7761 17.7156 28.757 15.2551 26.6667 14.0481",
                stroke: "currentColor",
                strokeWidth: "2.66667",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M26.6227 23.3105C26.8773 25.2808 26.0158 27.2292 24.3871 28.3667C22.7584 29.5042 20.6324 29.6422 18.8703 28.7247C17.1083 27.8073 16.0021 25.9865 16 23.9999C15.9979 25.9865 14.8918 27.8073 13.1297 28.7247C11.3676 29.6422 9.24168 29.5042 7.61295 28.3667C5.98423 27.2292 5.12271 25.2808 5.37736 23.3105",
                stroke: "currentColor",
                strokeWidth: "2.66667",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M8.00002 24.0001C5.58622 24 3.4734 22.3787 2.84866 20.0471C2.22391 17.7156 3.243 15.2551 5.33336 14.0481",
                stroke: "currentColor",
                strokeWidth: "2.66667",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M8.00399 6.83325C6.41596 7.24157 5.10402 8.35767 4.44645 9.85972C3.78888 11.3618 3.85878 13.0828 4.63599 14.5266",
                stroke: "currentColor",
                strokeWidth: "2.66667",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    }));
};
var WhySgSecurityCheckMiniIcon = function(param) {
    var className = param.className;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        className: className,
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": true,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            d: "M16.6667 5L7.5 14.1667 3.33333 10",
            stroke: "currentColor",
            strokeWidth: "1.67",
            strokeLinecap: "round",
            strokeLinejoin: "round"
        })
    });
};
var WhySgSecurityBadgeCertifiedIcon = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        width: 14,
        height: 14,
        viewBox: "0 0 14 14",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props), {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                clipPath: "url(#whySgBadgeCertifiedClip)",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M11.6667 7.58343C11.6667 10.5001 9.62504 11.9584 7.19837 12.8043C7.0713 12.8473 6.93327 12.8453 6.80754 12.7984C4.37504 11.9584 2.33337 10.5001 2.33337 7.58343V3.5001C2.33337 3.17815 2.59476 2.91677 2.91671 2.91677C4.08337 2.91677 5.54171 2.21677 6.55671 1.3301C6.81202 1.11197 7.18806 1.11197 7.44337 1.3301C8.46421 2.2226 9.91671 2.91677 11.0834 2.91677C11.4055 2.91677 11.6667 3.17793 11.6667 3.5001V7.58343",
                        stroke: "currentColor",
                        strokeWidth: "1.16667",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M5.25 6.99992L6.41667 8.16659L8.75 5.83325",
                        stroke: "currentColor",
                        strokeWidth: "1.16667",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("defs", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("clipPath", {
                    id: "whySgBadgeCertifiedClip",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                        width: "14",
                        height: "14",
                        fill: "white"
                    })
                })
            })
        ]
    }));
};
var WhySgSecurityBadgeSslLockIcon = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        width: 14,
        height: 14,
        viewBox: "0 0 14 14",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props), {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                clipPath: "url(#whySgBadgeSslClip)",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M2.91667 6.41675H11.0833C11.7272 6.41675 12.25 6.93951 12.25 7.58341V11.6667C12.25 12.3106 11.7272 12.8334 11.0833 12.8334H2.91667C2.27277 12.8334 1.75 12.3106 1.75 11.6667V7.58341C1.75 6.93951 2.27277 6.41675 2.91667 6.41675V6.41675",
                        stroke: "currentColor",
                        strokeWidth: "1.16667",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M4.08337 6.41675V4.08341C4.08337 2.47366 5.39029 1.16675 7.00004 1.16675C8.60979 1.16675 9.91671 2.47366 9.91671 4.08341V6.41675",
                        stroke: "currentColor",
                        strokeWidth: "1.16667",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("defs", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("clipPath", {
                    id: "whySgBadgeSslClip",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                        width: "14",
                        height: "14",
                        fill: "white"
                    })
                })
            })
        ]
    }));
};
var WhySgSecurityBadgeAiPoweredIcon = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        width: 14,
        height: 14,
        viewBox: "0 0 14 14",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props), {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                clipPath: "url(#whySgBadgeAiPoweredClip)",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M6.4266 1.64151C6.47816 1.36543 6.71915 1.16528 7.00001 1.16528C7.28087 1.16528 7.52186 1.36543 7.57343 1.64151L8.18651 4.88368C8.27563 5.35541 8.64461 5.7244 9.11635 5.81351L12.3585 6.4266C12.6346 6.47816 12.8347 6.71915 12.8347 7.00001C12.8347 7.28087 12.6346 7.52186 12.3585 7.57343L9.11635 8.18651C8.64461 8.27563 8.27563 8.64461 8.18651 9.11635L7.57343 12.3585C7.52186 12.6346 7.28087 12.8347 7.00001 12.8347C6.71915 12.8347 6.47816 12.6346 6.4266 12.3585L5.81351 9.11635C5.7244 8.64461 5.35541 8.27563 4.88368 8.18651L1.64151 7.57343C1.36543 7.52186 1.16528 7.28087 1.16528 7.00001C1.16528 6.71915 1.36543 6.47816 1.64151 6.4266L4.88368 5.81351C5.35541 5.7244 5.7244 5.35541 5.81351 4.88368L6.4266 1.64151",
                        stroke: "currentColor",
                        strokeWidth: "1.16667",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M11.6667 1.16675V3.50008",
                        stroke: "currentColor",
                        strokeWidth: "1.16667",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M12.8333 2.33325H10.5",
                        stroke: "currentColor",
                        strokeWidth: "1.16667",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M1.16669 11.6667C1.16669 12.3106 1.68945 12.8333 2.33335 12.8333C2.97725 12.8333 3.50002 12.3106 3.50002 11.6667C3.50002 11.0228 2.97725 10.5 2.33335 10.5C1.68945 10.5 1.16669 11.0228 1.16669 11.6667H1.16669",
                        stroke: "currentColor",
                        strokeWidth: "1.16667",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("defs", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("clipPath", {
                    id: "whySgBadgeAiPoweredClip",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                        width: "14",
                        height: "14",
                        fill: "white"
                    })
                })
            })
        ]
    }));
};
var WhySgSecurityBadge3dsFingerprintIcon = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        width: 14,
        height: 14,
        viewBox: "0 0 14 14",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props), {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                clipPath: "url(#whySgBadge3dsClip)",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M6.99997 5.83325C6.35607 5.83325 5.83331 6.35602 5.83331 6.99992C5.83331 7.59492 5.77497 8.46409 5.68164 9.33325",
                        stroke: "currentColor",
                        strokeWidth: "1.16667",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M8.16665 7.65332C8.16665 9.04165 8.16665 11.375 7.58331 12.8333",
                        stroke: "currentColor",
                        strokeWidth: "1.16667",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M10.0858 12.2617C10.1558 11.9117 10.3366 10.92 10.3775 10.5",
                        stroke: "currentColor",
                        strokeWidth: "1.16667",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M1.16669 6.99997C1.16669 4.48912 2.77336 2.25998 5.15536 1.46598C7.53735 0.671984 10.1602 1.49129 11.6667 3.49997",
                        stroke: "currentColor",
                        strokeWidth: "1.16667",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M1.16669 9.33325H1.17252",
                        stroke: "currentColor",
                        strokeWidth: "1.16667",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M12.7167 9.33325C12.8333 8.16659 12.7931 6.21009 12.7167 5.83325",
                        stroke: "currentColor",
                        strokeWidth: "1.16667",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M2.91669 11.3749C3.20835 10.4999 3.50002 8.74992 3.50002 6.99992C3.49943 6.60259 3.5665 6.20806 3.69835 5.83325",
                        stroke: "currentColor",
                        strokeWidth: "1.16667",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M5.04584 12.8334C5.16834 12.4484 5.30834 12.0634 5.37834 11.6667",
                        stroke: "currentColor",
                        strokeWidth: "1.16667",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M5.25 3.96671C6.33325 3.3413 7.66792 3.34151 8.75097 3.96727C9.83402 4.59304 10.5008 5.74922 10.5 7.00005V8.16671",
                        stroke: "currentColor",
                        strokeWidth: "1.16667",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("defs", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("clipPath", {
                    id: "whySgBadge3dsClip",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                        width: "14",
                        height: "14",
                        fill: "white"
                    })
                })
            })
        ]
    }));
};
var WhySgSecurityBannerMetricShieldIcon = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        width: 24,
        height: 24,
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props), {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            d: "M20 13C20 18 16.5 20.5 12.34 21.95C12.1222 22.0238 11.8855 22.0202 11.67 21.94C7.5 20.5 4 18 4 13V5.99996C4 5.44805 4.44808 4.99996 5 4.99996C7 4.99996 9.5 3.79996 11.24 2.27996C11.6777 1.90603 12.3223 1.90603 12.76 2.27996C14.51 3.80996 17 4.99996 19 4.99996C19.5523 4.99996 20 5.44768 20 5.99996V13",
            stroke: "currentColor",
            strokeWidth: 2,
            strokeLinecap: "round",
            strokeLinejoin: "round"
        })
    }));
};
var WhySgSecurityBannerMetricLockIcon = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        width: 24,
        height: 24,
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props), {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M5 11H19C20.1038 11 21 11.8962 21 13V20C21 21.1038 20.1038 22 19 22H5C3.89617 22 3 21.1038 3 20V13C3 11.8962 3.89617 11 5 11V11",
                stroke: "currentColor",
                strokeWidth: 2,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M7 11V7C7 4.24042 9.24042 2 12 2C14.7596 2 17 4.24042 17 7V11",
                stroke: "currentColor",
                strokeWidth: 2,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    }));
};
var WhySgSecurityBannerMetricSecuredIcon = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        width: 24,
        height: 24,
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props), {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M2.586 17.414C2.2109 17.789 2.00011 18.2976 2 18.828V21C2 21.552 2.44808 22 3 22H6C6.55192 22 7 21.552 7 21V20C7 19.4481 7.44808 19 8 19H9C9.55192 19 10 18.552 10 18V17C10 16.4481 10.4481 16 11 16H11.172C11.7024 15.9999 12.211 15.7891 12.586 15.414L13.4 14.6C16.2622 15.5971 19.4336 14.4836 21.0444 11.9162C22.6551 9.3487 22.2776 6.00877 20.1344 3.8656C17.9913 1.72244 14.6513 1.34494 12.0839 2.95568C9.51641 4.56642 8.40296 7.73782 9.4 10.6L2.586 17.414",
                stroke: "currentColor",
                strokeWidth: 2,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M16 7.5C16 7.77596 16.224 8 16.5 8C16.776 8 17 7.77596 17 7.5C17 7.22404 16.776 7 16.5 7C16.224 7 16 7.22404 16 7.5Z",
                fill: "currentColor"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M16 7.5C16 7.77596 16.224 8 16.5 8C16.776 8 17 7.77596 17 7.5C17 7.22404 16.776 7 16.5 7C16.224 7 16 7.22404 16 7.5V7.5",
                stroke: "currentColor",
                strokeWidth: 2,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    }));
};
var WhySgSecurityBannerMetricMonitoredIcon = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        width: 24,
        height: 24,
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props), {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M3 7V5C3 3.89617 3.89617 3 5 3H7",
                stroke: "currentColor",
                strokeWidth: 2,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M17 3H19C20.1038 3 21 3.89617 21 5V7",
                stroke: "currentColor",
                strokeWidth: 2,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M21 17V19C21 20.1038 20.1038 21 19 21H17",
                stroke: "currentColor",
                strokeWidth: 2,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M7 21H5C3.89617 21 3 20.1038 3 19V17",
                stroke: "currentColor",
                strokeWidth: 2,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M11 12C11 12.5519 11.4481 13 12 13C12.5519 13 13 12.5519 13 12C13 11.4481 12.5519 11 12 11C11.4481 11 11 11.4481 11 12V12",
                stroke: "currentColor",
                strokeWidth: 2,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M18.944 12.33C19.0187 12.1164 19.0187 11.8837 18.944 11.67C17.7924 8.84823 15.0477 7.00391 12 7.00391C8.95225 7.00391 6.20758 8.84823 5.05599 11.67C4.9813 11.8837 4.9813 12.1164 5.05599 12.33C6.20758 15.1518 8.95225 16.9962 12 16.9962C15.0477 16.9962 17.7924 15.1518 18.944 12.33",
                stroke: "currentColor",
                strokeWidth: 2,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    }));
};
var WhySgSecurityStatPciMedalIcon = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        viewBox: "0 0 32 32",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props), {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M20.636 17.1865L22.656 28.5545C22.7023 28.8286 22.5737 29.1027 22.3332 29.2423C22.0928 29.3818 21.791 29.3574 21.576 29.1812L16.8027 25.5985C16.3294 25.245 15.6799 25.245 15.2067 25.5985L10.4253 29.1799C10.2105 29.3558 9.90917 29.3801 9.66889 29.241C9.4286 29.1019 9.29971 28.8284 9.34534 28.5545L11.364 17.1865",
                stroke: "currentColor",
                strokeWidth: "2.66667",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M8 10.6665C8 15.0818 11.5847 18.6665 16 18.6665C20.4153 18.6665 24 15.0818 24 10.6665C24 6.25118 20.4153 2.6665 16 2.6665C11.5847 2.6665 8 6.25118 8 10.6665H8",
                stroke: "currentColor",
                strokeWidth: "2.66667",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    }));
};
var WhySgSecurityShieldAlertStatIcon = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props), {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M12 22s8-4 8-10V6l-8-4-8 4v6c0 6 8 10 8 10ZM12 8v4",
                stroke: "currentColor",
                strokeWidth: "1.5",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("circle", {
                cx: 12,
                cy: 16,
                r: 1,
                fill: "currentColor"
            })
        ]
    }));
};
var WhySgSecurityGlobeStatIcon = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props), {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("circle", {
                cx: 12,
                cy: 12,
                r: 9,
                stroke: "currentColor",
                strokeWidth: "1.5"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M3 12h18M12 3a15 15 0 0 1 0 18M12 3a15 15 0 0 0 0 18",
                stroke: "currentColor",
                strokeWidth: "1.5",
                strokeLinecap: "round"
            })
        ]
    }));
};

// EXTERNAL MODULE: ./src/components/landingV4/WhySgSecurityBlock/WhySgSecurityBlock.module.scss
var WhySgSecurityBlock_module = __webpack_require__(22596);
var WhySgSecurityBlock_module_default = /*#__PURE__*/__webpack_require__.n(WhySgSecurityBlock_module);
;// CONCATENATED MODULE: ./src/components/landingV4/WhySgSecurityBlock/WhySgSecurityBlock.tsx







function ListItem(props) {
    var children = props.children;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
        className: (WhySgSecurityBlock_module_default()).listItem,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(WhySgSecurityCheckMiniIcon, {
                className: (WhySgSecurityBlock_module_default()).checkIcon
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Text */.x, {
                type: "regular14",
                color: "white",
                whiteSpace: "normal",
                children: children
            })
        ]
    });
}
var WhySgSecurityBlock = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* Container */.W, {
        className: (WhySgSecurityBlock_module_default()).root,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: (WhySgSecurityBlock_module_default()).layout,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (WhySgSecurityBlock_module_default()).sectionLabel,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: (WhySgSecurityBlock_module_default()).sectionLabelLine,
                            "aria-hidden": true
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Text */.x, {
                            type: "medium14",
                            color: "green",
                            className: (WhySgSecurityBlock_module_default()).sectionEyebrow,
                            children: "Security"
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* Flex */.k, {
                    direction: "column",
                    gap: 6,
                    className: (WhySgSecurityBlock_module_default()).intro,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Text */.x, {
                            type: "regular48",
                            color: "white",
                            align: "center",
                            className: (WhySgSecurityBlock_module_default()).title,
                            children: "Enterprise-Grade Security"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Text */.x, {
                            type: "regular16",
                            color: "white50",
                            whiteSpace: "normal",
                            align: "center",
                            className: (WhySgSecurityBlock_module_default()).description,
                            children: "Comprehensive compliance and data protection built into every layer of our platform. We safeguard your transactions with industry-leading security standards and cutting-edge technology."
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (WhySgSecurityBlock_module_default()).featureGrid,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("article", {
                            className: (WhySgSecurityBlock_module_default()).card,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: (WhySgSecurityBlock_module_default()).cardInner,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* Flex */.k, {
                                        alignItems: "center",
                                        gap: 4,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* Flex */.k, {
                                                className: (WhySgSecurityBlock_module_default()).iconWrap,
                                                "aria-hidden": true,
                                                alignItems: "center",
                                                justifyContent: "center",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(WhySgShieldCheckSecurityCardIcon, {})
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* Flex */.k, {
                                                direction: "column",
                                                gap: 2,
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Text */.x, {
                                                        type: "medium14",
                                                        className: (WhySgSecurityBlock_module_default()).categoryLabel,
                                                        children: "Compliance"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Text */.x, {
                                                        type: "h3",
                                                        color: "white",
                                                        children: "PCI DSS Level 1"
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Text */.x, {
                                        type: "regular14",
                                        color: "white50",
                                        whiteSpace: "normal",
                                        children: "Full PCI DSS Level 1 certification — the highest level of payment security compliance. Your customers' sensitive data is protected by the same standards used by the world's largest financial institutions."
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                                        className: (WhySgSecurityBlock_module_default()).list,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ListItem, {
                                                children: "Annual on-site security audits"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ListItem, {
                                                children: "End-to-end encryption (E2EE)"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ListItem, {
                                                children: "Tokenization of card data"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ListItem, {
                                                children: "SOC 2 Type II compliant"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: (WhySgSecurityBlock_module_default()).badgesRow,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                className: (WhySgSecurityBlock_module_default()).badgeAccent,
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(WhySgSecurityBadgeCertifiedIcon, {
                                                        "aria-hidden": true
                                                    }),
                                                    "Certified"
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                className: (WhySgSecurityBlock_module_default()).badgeMuted,
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(WhySgSecurityBadgeSslLockIcon, {
                                                        "aria-hidden": true
                                                    }),
                                                    "256-bit SSL"
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("article", {
                            className: (WhySgSecurityBlock_module_default()).card,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: (WhySgSecurityBlock_module_default()).cardInner,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* Flex */.k, {
                                        alignItems: "center",
                                        gap: 4,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* Flex */.k, {
                                                className: (WhySgSecurityBlock_module_default()).iconWrap,
                                                "aria-hidden": true,
                                                alignItems: "center",
                                                justifyContent: "center",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(WhySgSecurityTechnologyCardIcon, {})
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* Flex */.k, {
                                                direction: "column",
                                                gap: 2,
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Text */.x, {
                                                        type: "medium14",
                                                        className: (WhySgSecurityBlock_module_default()).categoryLabel,
                                                        children: "Technology"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Text */.x, {
                                                        type: "h3",
                                                        color: "white",
                                                        children: "AI Anti-Fraud Suite"
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Text */.x, {
                                        type: "regular14",
                                        color: "white50",
                                        whiteSpace: "normal",
                                        children: "AI-powered anti-fraud suite and 3D-Secure 2.0 to significantly reduce chargeback risks. Our machine learning models analyze thousands of signals in real-time to detect and prevent fraudulent transactions."
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                                        className: (WhySgSecurityBlock_module_default()).list,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ListItem, {
                                                children: "Real-time fraud scoring"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ListItem, {
                                                children: "3D-Secure 2.0 integration"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ListItem, {
                                                children: "Adaptive risk engine"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ListItem, {
                                                children: "Chargeback reduction up to 70%"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: (WhySgSecurityBlock_module_default()).badgesRow,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                className: (WhySgSecurityBlock_module_default()).badgeAccent,
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(WhySgSecurityBadgeAiPoweredIcon, {
                                                        "aria-hidden": true
                                                    }),
                                                    "AI-Powered"
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                className: (WhySgSecurityBlock_module_default()).badgeMuted,
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(WhySgSecurityBadge3dsFingerprintIcon, {
                                                        "aria-hidden": true
                                                    }),
                                                    "3DS 2.0"
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (WhySgSecurityBlock_module_default()).banner,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (WhySgSecurityBlock_module_default()).bannerInner,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* Flex */.k, {
                                direction: "column",
                                gap: 2,
                                className: (WhySgSecurityBlock_module_default()).bannerText,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Text */.x, {
                                        type: "h2",
                                        color: "white",
                                        children: "Trusted by 10,000+ Merchants Worldwide"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Text */.x, {
                                        type: "regular16",
                                        color: "white50",
                                        whiteSpace: "normal",
                                        className: (WhySgSecurityBlock_module_default()).bannerSubtitle,
                                        children: "Processing billions in secure transactions every year"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (WhySgSecurityBlock_module_default()).bannerMetrics,
                                children: [
                                    {
                                        Icon: WhySgSecurityBannerMetricShieldIcon,
                                        label: "Protected"
                                    },
                                    {
                                        Icon: WhySgSecurityBannerMetricLockIcon,
                                        label: "Encrypted"
                                    },
                                    {
                                        Icon: WhySgSecurityBannerMetricSecuredIcon,
                                        label: "Secured"
                                    },
                                    {
                                        Icon: WhySgSecurityBannerMetricMonitoredIcon,
                                        label: "Monitored"
                                    }, 
                                ].map(function(param) {
                                    var Icon = param.Icon, label = param.label;
                                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: (WhySgSecurityBlock_module_default()).metricItem,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: (WhySgSecurityBlock_module_default()).metricIcon,
                                                "aria-hidden": true,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon, {})
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Text */.x, {
                                                type: "regular12",
                                                className: (WhySgSecurityBlock_module_default()).metricLabel,
                                                children: label
                                            })
                                        ]
                                    }, label);
                                })
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (WhySgSecurityBlock_module_default()).statsGrid,
                    children: [
                        {
                            Icon: WhySgShieldCheckUptimeStatIcon,
                            value: "99.99%",
                            label: "Uptime SLA"
                        },
                        {
                            Icon: WhySgSecurityShieldAlertStatIcon,
                            value: "0.01%",
                            label: "Fraud Rate"
                        },
                        {
                            Icon: WhySgSecurityStatPciMedalIcon,
                            value: "Level 1",
                            label: "PCI DSS"
                        },
                        {
                            Icon: WhySgSecurityGlobeStatIcon,
                            value: "150+",
                            label: "Countries"
                        }, 
                    ].map(function(param) {
                        var Icon = param.Icon, value = param.value, label = param.label;
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)("article", {
                            className: (WhySgSecurityBlock_module_default()).statCard,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: (WhySgSecurityBlock_module_default()).statCardInner,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: (WhySgSecurityBlock_module_default()).statIcon,
                                        "aria-hidden": true,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon, {})
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: (WhySgSecurityBlock_module_default()).statValue,
                                        children: value
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Text */.x, {
                                        type: "regular12",
                                        color: "white50",
                                        align: "center",
                                        whiteSpace: "normal",
                                        className: (WhySgSecurityBlock_module_default()).statCaption,
                                        children: label
                                    })
                                ]
                            })
                        }, label);
                    })
                })
            ]
        })
    });
};

;// CONCATENATED MODULE: ./src/components/landingV4/WhySgSecurityBlock/index.ts


// EXTERNAL MODULE: ./src/constants/sections.ts
var sections = __webpack_require__(6872);
// EXTERNAL MODULE: ./src/hooks/use-lk-base-path.ts
var use_lk_base_path = __webpack_require__(14620);
// EXTERNAL MODULE: ./src/components/landingV4/common/ButtonLink/index.ts + 1 modules
var ButtonLink = __webpack_require__(64791);
// EXTERNAL MODULE: ./src/components/landingV4/common/Link/index.ts + 1 modules
var Link = __webpack_require__(43602);
;// CONCATENATED MODULE: ./src/components/landingV4/whySg/icons/WhySgSmartRoutingIcons.tsx

var WhySgSmartRoutingImpactTrendIcon = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": true,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M2.5 13.3333 6.90476 8.92857 10.7143 12.7381 17.5 5.95238",
                stroke: "currentColor",
                strokeWidth: "1.66667",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M12.5 5H17.5V10",
                stroke: "currentColor",
                strokeWidth: "1.66667",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    });
};
var WhySgSmartRoutingValueMoneyIcon = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": true,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M10 1.66675V18.3334",
                stroke: "currentColor",
                strokeWidth: "1.66667",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M14.1667 4.16675H7.91667C6.30691 4.16675 5 5.47366 5 7.08341C5 8.69317 6.30691 10.0001 7.91667 10.0001H12.0833C13.6931 10.0001 15 11.307 15 12.9167C15 14.5265 13.6931 15.8334 12.0833 15.8334H5",
                stroke: "currentColor",
                strokeWidth: "1.66667",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    });
};

// EXTERNAL MODULE: ./src/components/landingV4/WhySgSmartRoutingBlock/WhySgSmartRoutingBlock.module.scss
var WhySgSmartRoutingBlock_module = __webpack_require__(52090);
var WhySgSmartRoutingBlock_module_default = /*#__PURE__*/__webpack_require__.n(WhySgSmartRoutingBlock_module);
;// CONCATENATED MODULE: ./src/components/landingV4/WhySgSmartRoutingBlock/WhySgSmartRoutingBlock.tsx











var ROUTING_DIAGRAM_SRC = "/assets/why_sg_routing_diagram.png";
var WhySgSmartRoutingBlock = function() {
    var lkBasePath = (0,use_lk_base_path/* useLkBasePath */.v)();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* Container */.W, {
        className: (WhySgSmartRoutingBlock_module_default()).root,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: (WhySgSmartRoutingBlock_module_default()).layout,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* Flex */.k, {
                    direction: "column",
                    gap: 4,
                    className: (WhySgSmartRoutingBlock_module_default()).intro,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: (WhySgSmartRoutingBlock_module_default()).sectionLabel,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: (WhySgSmartRoutingBlock_module_default()).sectionLabelLine,
                                    "aria-hidden": true
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Text */.x, {
                                    type: "medium14",
                                    color: "green",
                                    className: (WhySgSmartRoutingBlock_module_default()).sectionEyebrow,
                                    children: "Smart Routing"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Text */.x, {
                            type: "regular48",
                            color: "white",
                            className: (WhySgSmartRoutingBlock_module_default()).title,
                            children: "Maximize Revenue with Smart Routing"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Text */.x, {
                            type: "regular16",
                            color: "white50",
                            whiteSpace: "normal",
                            className: (WhySgSmartRoutingBlock_module_default()).description,
                            children: "Our intelligent routing engine analyzes hundreds of variables in real-time to determine the optimal path for every transaction — maximizing approval rates and minimizing costs."
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (WhySgSmartRoutingBlock_module_default()).cardsDiagramRow,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: (WhySgSmartRoutingBlock_module_default()).cardsColumn,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("article", {
                                    className: (WhySgSmartRoutingBlock_module_default()).card,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* Flex */.k, {
                                        className: (WhySgSmartRoutingBlock_module_default()).cardInner,
                                        direction: "column",
                                        alignItems: "flexStart",
                                        gap: 4,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* Flex */.k, {
                                                direction: "row",
                                                alignItems: "center",
                                                gap: 4,
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* Flex */.k, {
                                                        className: (WhySgSmartRoutingBlock_module_default()).iconWrap,
                                                        alignItems: "center",
                                                        justifyContent: "center",
                                                        "aria-hidden": true,
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(WhySgSmartRoutingImpactTrendIcon, {})
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Text */.x, {
                                                        type: "medium16",
                                                        color: "white",
                                                        children: "Impact"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text/* Text */.x, {
                                                type: "medium18",
                                                color: "white",
                                                children: [
                                                    "Boost your Approval Ratio by up to ",
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        className: (WhySgSmartRoutingBlock_module_default()).highlight,
                                                        children: "20%"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Text */.x, {
                                                type: "regular14",
                                                color: "white50",
                                                whiteSpace: "normal",
                                                children: "Real-time analysis of transaction data, card type, geography and acquirer performance to route each payment optimally."
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("article", {
                                    className: (WhySgSmartRoutingBlock_module_default()).card,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* Flex */.k, {
                                        className: (WhySgSmartRoutingBlock_module_default()).cardInner,
                                        direction: "column",
                                        alignItems: "flexStart",
                                        gap: 4,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* Flex */.k, {
                                                direction: "row",
                                                alignItems: "center",
                                                gap: 4,
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* Flex */.k, {
                                                        className: (WhySgSmartRoutingBlock_module_default()).iconWrap,
                                                        alignItems: "center",
                                                        justifyContent: "center",
                                                        "aria-hidden": true,
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(WhySgSmartRoutingValueMoneyIcon, {})
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Text */.x, {
                                                        type: "medium16",
                                                        color: "white",
                                                        children: "Value"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Text */.x, {
                                                type: "medium18",
                                                color: "white",
                                                whiteSpace: "normal",
                                                children: "Reduce failed transactions and capture more revenue automatically"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Text */.x, {
                                                type: "regular14",
                                                color: "white50",
                                                whiteSpace: "normal",
                                                children: "Automatic failover and retry logic ensures no revenue is left on the table. Smart cascading across multiple acquirers."
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* Flex */.k, {
                                    className: (WhySgSmartRoutingBlock_module_default()).actions,
                                    wrap: "wrap",
                                    alignItems: "center",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonLink/* ButtonLink */.Z, {
                                            className: (WhySgSmartRoutingBlock_module_default()).ctaFilled,
                                            href: "".concat(lkBasePath, "/registration"),
                                            isOutsideLink: true,
                                            children: "Become a merchant"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* Link */.r, {
                                            href: "#".concat(sections/* SECTIONS_IDS.contact */.s.contact),
                                            className: (WhySgSmartRoutingBlock_module_default()).docsLink,
                                            children: "Request demo"
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (WhySgSmartRoutingBlock_module_default()).diagramWrap,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                className: (WhySgSmartRoutingBlock_module_default()).diagram,
                                src: ROUTING_DIAGRAM_SRC,
                                alt: "Diagram: routing engine linking payment methods to acquirers with approval rates",
                                width: 1012,
                                height: 1042,
                                layout: "responsive",
                                sizes: "(min-width: 960px) 50vw, 100vw"
                            })
                        })
                    ]
                })
            ]
        })
    });
};

;// CONCATENATED MODULE: ./src/components/landingV4/WhySgSmartRoutingBlock/index.ts


;// CONCATENATED MODULE: ./src/components/landingV4/whySg/icons/WhySgTimeToMarketIcons.tsx

var WhySgTimeToMarketSpeedIcon = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": true,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M8.33337 1.6665H11.6667",
                stroke: "currentColor",
                strokeWidth: "1.66667",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M10 11.6665L12.5 9.1665",
                stroke: "currentColor",
                strokeWidth: "1.66667",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M3.33337 11.6667C3.33337 15.3461 6.32061 18.3333 10 18.3333C13.6795 18.3333 16.6667 15.3461 16.6667 11.6667C16.6667 7.98723 13.6795 5 10 5C6.32061 5 3.33337 7.98723 3.33337 11.6667V11.6667",
                stroke: "currentColor",
                strokeWidth: "1.66667",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    });
};
var WhySgTimeToMarketEfficiencyIcon = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": true,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("defs", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("clipPath", {
                    id: "clip_sg_time_to_market_efficiency",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                        width: "20",
                        height: "20",
                        fill: "white"
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                clipPath: "url(#clip_sg_time_to_market_efficiency)",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M8.33329 18.3333V5.83333C8.33329 5.3731 7.9602 5 7.49996 5H3.33329C2.41282 5 1.66663 5.74619 1.66663 6.66667V16.6667C1.66663 17.5871 2.41282 18.3333 3.33329 18.3333H13.3333C14.2538 18.3333 15 17.5871 15 16.6667V12.5C15 12.0398 14.6269 11.6667 14.1666 11.6667H1.66663",
                        stroke: "currentColor",
                        strokeWidth: "1.66667",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M12.5 1.6665H17.5C17.9602 1.6665 18.3333 2.0396 18.3333 2.49984V7.49984C18.3333 7.96007 17.9602 8.33317 17.5 8.33317H12.5C12.0397 8.33317 11.6666 7.96007 11.6666 7.49984V2.49984C11.6666 2.0396 12.0397 1.6665 12.5 1.6665V1.6665",
                        stroke: "currentColor",
                        strokeWidth: "1.66667",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    })
                ]
            })
        ]
    });
};
var WhySgTimeToMarketTrendZigzagIcon = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        viewBox: "0 0 28 28",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": true,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M4 20L11 13L17 17L23 9",
                stroke: "currentColor",
                strokeWidth: "2",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M18 9H23V14",
                stroke: "currentColor",
                strokeWidth: "2",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    });
};
var WhySgTimeToMarketTimelineCheckIcon = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": true,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            d: "M6 12L10.5 16.5L18 9",
            stroke: "currentColor",
            strokeWidth: "2",
            strokeLinecap: "round",
            strokeLinejoin: "round"
        })
    });
};

// EXTERNAL MODULE: ./src/components/landingV4/WhySgTimeToMarketBlock/WhySgTimeToMarketBlock.module.scss
var WhySgTimeToMarketBlock_module = __webpack_require__(15275);
var WhySgTimeToMarketBlock_module_default = /*#__PURE__*/__webpack_require__.n(WhySgTimeToMarketBlock_module);
;// CONCATENATED MODULE: ./src/components/landingV4/WhySgTimeToMarketBlock/WhySgTimeToMarketBlock.tsx










var TIMELINE_STEPS = [
    {
        title: "Integration Setup",
        range: "Day 1–3"
    },
    {
        title: "SDK Configuration",
        range: "Day 4–7"
    },
    {
        title: "Testing & QA",
        range: "Day 8–12"
    },
    {
        title: "Go Live!",
        range: "Day 14",
        final: true
    }, 
];
var WhySgTimeToMarketBlock = function() {
    var lkBasePath = (0,use_lk_base_path/* useLkBasePath */.v)();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* Container */.W, {
        className: (WhySgTimeToMarketBlock_module_default()).root,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: (WhySgTimeToMarketBlock_module_default()).layout,
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (WhySgTimeToMarketBlock_module_default()).contentRow,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (WhySgTimeToMarketBlock_module_default()).leftColumn,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* Flex */.k, {
                                direction: "column",
                                gap: 4,
                                className: (WhySgTimeToMarketBlock_module_default()).intro,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: (WhySgTimeToMarketBlock_module_default()).sectionLabel,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                className: (WhySgTimeToMarketBlock_module_default()).sectionLabelLine,
                                                "aria-hidden": true
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Text */.x, {
                                                type: "medium14",
                                                color: "green",
                                                className: (WhySgTimeToMarketBlock_module_default()).sectionEyebrow,
                                                children: "Time-to-market"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Text */.x, {
                                        type: "regular48",
                                        color: "white",
                                        className: (WhySgTimeToMarketBlock_module_default()).title,
                                        children: "Rapid Time-to-Market"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Text */.x, {
                                        type: "regular16",
                                        color: "white50",
                                        whiteSpace: "normal",
                                        className: (WhySgTimeToMarketBlock_module_default()).description,
                                        children: "Launch your payment platform faster than ever. Our turnkey infrastructure and pre-built components eliminate months of development, letting you focus on what matters — your business."
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: (WhySgTimeToMarketBlock_module_default()).featureCards,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: (WhySgTimeToMarketBlock_module_default()).featureRow,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* Flex */.k, {
                                                className: (WhySgTimeToMarketBlock_module_default()).iconWrap,
                                                alignItems: "center",
                                                justifyContent: "center",
                                                "aria-hidden": true,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(WhySgTimeToMarketSpeedIcon, {})
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: (WhySgTimeToMarketBlock_module_default()).featureBody,
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Text */.x, {
                                                        type: "medium16",
                                                        color: "white",
                                                        children: "Speed"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Text */.x, {
                                                        type: "regular14",
                                                        color: "white50",
                                                        whiteSpace: "normal",
                                                        children: "Go live in as little as 2 weeks"
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: (WhySgTimeToMarketBlock_module_default()).featureRow,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* Flex */.k, {
                                                className: (WhySgTimeToMarketBlock_module_default()).iconWrap,
                                                alignItems: "center",
                                                justifyContent: "center",
                                                "aria-hidden": true,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(WhySgTimeToMarketEfficiencyIcon, {})
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: (WhySgTimeToMarketBlock_module_default()).featureBody,
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Text */.x, {
                                                        type: "medium16",
                                                        color: "white",
                                                        children: "Efficiency"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Text */.x, {
                                                        type: "regular14",
                                                        color: "white50",
                                                        whiteSpace: "normal",
                                                        children: "Use our comprehensive SDKs and pre-built modules to launch your platform instantly"
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* Flex */.k, {
                                className: (WhySgTimeToMarketBlock_module_default()).actions,
                                wrap: "wrap",
                                alignItems: "center",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonLink/* ButtonLink */.Z, {
                                        className: (WhySgTimeToMarketBlock_module_default()).ctaFilled,
                                        href: "".concat(lkBasePath, "/registration"),
                                        isOutsideLink: true,
                                        children: "Get Started Now"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* Link */.r, {
                                        href: "/docs",
                                        className: (WhySgTimeToMarketBlock_module_default()).docsLink,
                                        children: "View Documentation"
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("aside", {
                        className: (WhySgTimeToMarketBlock_module_default()).timelineCard,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: (WhySgTimeToMarketBlock_module_default()).badgeWeeks,
                                children: "2 Weeks"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: (WhySgTimeToMarketBlock_module_default()).timelineCardInner,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("header", {
                                        className: (WhySgTimeToMarketBlock_module_default()).timelineHeader,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Text */.x, {
                                                type: "medium14",
                                                color: "green",
                                                className: (WhySgTimeToMarketBlock_module_default()).timelineEyebrow,
                                                children: "Launch timeline"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: (WhySgTimeToMarketBlock_module_default()).timelineHeaderAside,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    className: (WhySgTimeToMarketBlock_module_default()).timelineTrendIcon,
                                                    "aria-hidden": true,
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(WhySgTimeToMarketTrendZigzagIcon, {})
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                                        className: (WhySgTimeToMarketBlock_module_default()).timelineList,
                                        children: TIMELINE_STEPS.map(function(step, index) {
                                            return /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                                className: (WhySgTimeToMarketBlock_module_default()).timelineItem,
                                                children: [
                                                    step.final ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: (0,clsx_m/* default */.Z)((WhySgTimeToMarketBlock_module_default()).timelineMarker, (WhySgTimeToMarketBlock_module_default()).timelineMarkerDone),
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(WhySgTimeToMarketTimelineCheckIcon, {})
                                                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: (WhySgTimeToMarketBlock_module_default()).timelineMarker,
                                                        children: index + 1
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Text */.x, {
                                                        type: "medium14",
                                                        color: step.final ? "green" : "white",
                                                        className: (WhySgTimeToMarketBlock_module_default()).timelineStepTitle,
                                                        children: step.title
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Text */.x, {
                                                        type: "regular12",
                                                        color: "white50",
                                                        className: (WhySgTimeToMarketBlock_module_default()).timelineRange,
                                                        children: step.range
                                                    })
                                                ]
                                            }, step.title);
                                        })
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        })
    });
};

;// CONCATENATED MODULE: ./src/components/landingV4/WhySgTimeToMarketBlock/index.ts


// EXTERNAL MODULE: ./src/components/layout/MainLayout/EmptyLayout.tsx
var EmptyLayout = __webpack_require__(46615);
;// CONCATENATED MODULE: ./src/pages/why-sg.tsx














var Page = function() {
    (0,react.useLayoutEffect)(function() {
        document.documentElement.classList.add("v4");
        document.documentElement.style.setProperty("--background", "#09090B");
        return function() {
            document.documentElement.classList.remove("v4");
            document.documentElement.style.removeProperty("--background");
        };
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(SnackbarProvider/* SnackbarProvider */.w, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)((head_default()), {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                        children: "Why SmartGate | SmartGates"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "description",
                        content: "Scale your business with an intelligent data-driven payment ecosystem — security, smart routing and unified analytics."
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Header/* Header */.h, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(WhySgHero, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(WhySgSmartRoutingBlock, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(WhySgSecurityBlock, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(WhySgTimeToMarketBlock, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(WhySgGlobalCoverageBlock, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(FAQBlock/* FAQBlock */.C, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(FeedbackBlock/* FeedbackBlock */.O, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Footer/* Footer */.$, {})
        ]
    });
};
Page.getLayout = function(page) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(EmptyLayout/* EmptyLayout */.T, {
        withFloatMenu: false,
        children: page
    });
};
var __N_SSG = true;
/* harmony default export */ var why_sg = (Page);


/***/ }),

/***/ 62267:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"root":"WhySgGlobalCoverageBlock_root__UYlO_","layout":"WhySgGlobalCoverageBlock_layout__EZn40","sectionLabel":"WhySgGlobalCoverageBlock_sectionLabel__5NAnM","sectionLabelLine":"WhySgGlobalCoverageBlock_sectionLabelLine__HJeFj","sectionEyebrow":"WhySgGlobalCoverageBlock_sectionEyebrow___YDou","intro":"WhySgGlobalCoverageBlock_intro__3ShDb","title":"WhySgGlobalCoverageBlock_title__qimmB","description":"WhySgGlobalCoverageBlock_description__Dt6t4","contentRow":"WhySgGlobalCoverageBlock_contentRow__Cf_4_","leftColumn":"WhySgGlobalCoverageBlock_leftColumn__lBR87","featureGrid":"WhySgGlobalCoverageBlock_featureGrid__PN5EC","featureChip":"WhySgGlobalCoverageBlock_featureChip__yHWN7","featureChipSolo":"WhySgGlobalCoverageBlock_featureChipSolo__VsO4T","featureChipIcon":"WhySgGlobalCoverageBlock_featureChipIcon__21n7M","statsRow":"WhySgGlobalCoverageBlock_statsRow__0Jp7b","statItem":"WhySgGlobalCoverageBlock_statItem__owjMp","statValue":"WhySgGlobalCoverageBlock_statValue__bXI_3","visualColumn":"WhySgGlobalCoverageBlock_visualColumn__PJNOL","mapFigure":"WhySgGlobalCoverageBlock_mapFigure__tYuZM","mapImg":"WhySgGlobalCoverageBlock_mapImg__8wtYZ","providers":"WhySgGlobalCoverageBlock_providers__GmB9G","providersRow":"WhySgGlobalCoverageBlock_providersRow__ojZUb","providerTag":"WhySgGlobalCoverageBlock_providerTag__otw_0"};

/***/ }),

/***/ 29961:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"root":"WhySgHero_root__ZwysF","intro":"WhySgHero_intro__HFS5_","eyebrow":"WhySgHero_eyebrow__sATrL","headline":"WhySgHero_headline__4Rdwg","subhead":"WhySgHero_subhead__Vw8nl","slider":"WhySgHero_slider___2343","card":"WhySgHero_card__rlDf4","cardInner":"WhySgHero_cardInner__LaF5a","iconWrap":"WhySgHero_iconWrap__pb5M9","category":"WhySgHero_category__e4T34"};

/***/ }),

/***/ 22596:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"root":"WhySgSecurityBlock_root__PD0Hw","layout":"WhySgSecurityBlock_layout__ekWqQ","intro":"WhySgSecurityBlock_intro__vEXa2","sectionLabel":"WhySgSecurityBlock_sectionLabel__zmZdq","sectionLabelLine":"WhySgSecurityBlock_sectionLabelLine__M1_fL","sectionEyebrow":"WhySgSecurityBlock_sectionEyebrow__dNeRm","title":"WhySgSecurityBlock_title__WjEet","description":"WhySgSecurityBlock_description__4lM68","featureGrid":"WhySgSecurityBlock_featureGrid__Egygg","card":"WhySgSecurityBlock_card__gzJi_","cardInner":"WhySgSecurityBlock_cardInner__mSso6","iconWrap":"WhySgSecurityBlock_iconWrap__l2H7t","categoryLabel":"WhySgSecurityBlock_categoryLabel__CZPe8","list":"WhySgSecurityBlock_list__8FZFg","listItem":"WhySgSecurityBlock_listItem__ZEf6A","checkIcon":"WhySgSecurityBlock_checkIcon__tmGFG","badgesRow":"WhySgSecurityBlock_badgesRow__xbQjx","badgeAccent":"WhySgSecurityBlock_badgeAccent__zhEFF","badgeMuted":"WhySgSecurityBlock_badgeMuted__tlvC8","banner":"WhySgSecurityBlock_banner__VaWkW","bannerInner":"WhySgSecurityBlock_bannerInner__XKB_O","bannerText":"WhySgSecurityBlock_bannerText__d9nsC","bannerSubtitle":"WhySgSecurityBlock_bannerSubtitle__Ccn6G","bannerMetrics":"WhySgSecurityBlock_bannerMetrics____yJv","metricItem":"WhySgSecurityBlock_metricItem__Ms5qO","metricIcon":"WhySgSecurityBlock_metricIcon__5O6gr","metricLabel":"WhySgSecurityBlock_metricLabel__MeDQT","statsGrid":"WhySgSecurityBlock_statsGrid__CCjdY","statCard":"WhySgSecurityBlock_statCard__b7gQi","statCardInner":"WhySgSecurityBlock_statCardInner__rF_6V","statIcon":"WhySgSecurityBlock_statIcon__KosRb","statValue":"WhySgSecurityBlock_statValue__Wv9NQ","statCaption":"WhySgSecurityBlock_statCaption__US0sd"};

/***/ }),

/***/ 52090:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"root":"WhySgSmartRoutingBlock_root__x_irx","layout":"WhySgSmartRoutingBlock_layout__NfdZP","intro":"WhySgSmartRoutingBlock_intro__IrTx_","cardsDiagramRow":"WhySgSmartRoutingBlock_cardsDiagramRow__MWHlH","cardsColumn":"WhySgSmartRoutingBlock_cardsColumn__Cp6b6","sectionEyebrow":"WhySgSmartRoutingBlock_sectionEyebrow__9GvaZ","sectionLabel":"WhySgSmartRoutingBlock_sectionLabel__h7evO","sectionLabelLine":"WhySgSmartRoutingBlock_sectionLabelLine__MQTDY","title":"WhySgSmartRoutingBlock_title__6kuwQ","description":"WhySgSmartRoutingBlock_description__aVgVk","actions":"WhySgSmartRoutingBlock_actions__pNsvK","docsLink":"WhySgSmartRoutingBlock_docsLink__05X0B","ctaFilled":"WhySgSmartRoutingBlock_ctaFilled__SsBrj","card":"WhySgSmartRoutingBlock_card__mMtdd","cardInner":"WhySgSmartRoutingBlock_cardInner__8umhW","iconWrap":"WhySgSmartRoutingBlock_iconWrap__si8iM","highlight":"WhySgSmartRoutingBlock_highlight__Rg8nx","diagramWrap":"WhySgSmartRoutingBlock_diagramWrap__LMZl2","diagram":"WhySgSmartRoutingBlock_diagram__yc7Vr"};

/***/ }),

/***/ 15275:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"root":"WhySgTimeToMarketBlock_root__2bOQQ","layout":"WhySgTimeToMarketBlock_layout__gTTgU","sectionLabel":"WhySgTimeToMarketBlock_sectionLabel__bNgUU","sectionLabelLine":"WhySgTimeToMarketBlock_sectionLabelLine__scNwo","sectionEyebrow":"WhySgTimeToMarketBlock_sectionEyebrow__dMnWU","intro":"WhySgTimeToMarketBlock_intro__qndxb","title":"WhySgTimeToMarketBlock_title__x0gOq","description":"WhySgTimeToMarketBlock_description__61SgO","contentRow":"WhySgTimeToMarketBlock_contentRow__iZx_f","leftColumn":"WhySgTimeToMarketBlock_leftColumn__7MWLx","featureCards":"WhySgTimeToMarketBlock_featureCards__RVOYz","featureRow":"WhySgTimeToMarketBlock_featureRow__6jG4c","featureBody":"WhySgTimeToMarketBlock_featureBody__1oH2r","iconWrap":"WhySgTimeToMarketBlock_iconWrap__PiJ8v","actions":"WhySgTimeToMarketBlock_actions__7BbGT","docsLink":"WhySgTimeToMarketBlock_docsLink__JEU2N","ctaFilled":"WhySgTimeToMarketBlock_ctaFilled__bHe70","timelineCard":"WhySgTimeToMarketBlock_timelineCard__9N45X","timelineCardInner":"WhySgTimeToMarketBlock_timelineCardInner__lkE4n","timelineHeader":"WhySgTimeToMarketBlock_timelineHeader__pA4Xr","timelineHeaderAside":"WhySgTimeToMarketBlock_timelineHeaderAside__s_T3p","timelineEyebrow":"WhySgTimeToMarketBlock_timelineEyebrow__3314w","timelineTrendIcon":"WhySgTimeToMarketBlock_timelineTrendIcon__LgwcD","badgeWeeks":"WhySgTimeToMarketBlock_badgeWeeks__746sc","timelineList":"WhySgTimeToMarketBlock_timelineList__t2ZJd","timelineItem":"WhySgTimeToMarketBlock_timelineItem__malDH","timelineMarker":"WhySgTimeToMarketBlock_timelineMarker__kFGxG","timelineMarkerDone":"WhySgTimeToMarketBlock_timelineMarkerDone__MviJQ","timelineStepTitle":"WhySgTimeToMarketBlock_timelineStepTitle__k5Avu","timelineRange":"WhySgTimeToMarketBlock_timelineRange__5xd_z"};

/***/ }),

/***/ 97329:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"sliderWrapper":"Slider_sliderWrapper__gyBqO","sliderWrapperWithNav":"Slider_sliderWrapperWithNav__iMiw4","navBtn":"Slider_navBtn__AJ7FU","navPrev":"Slider_navPrev__mNsFU","navNext":"Slider_navNext___sm1Q","root":"Slider_root__qGRsc"};

/***/ }),

/***/ 65519:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 68770:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 9008:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(5443)


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [536,522,928,366,834,168,879,774,888,179], function() { return __webpack_exec__(15627); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);